import React from "react";
import { withRouter } from "react-router-dom";
import Presenter from "./Presenter";

import { useQuery } from "react-apollo-hooks";
import { ADMIN_DELIVERY_PLACE_LIST_QUERY } from "../Queries";

import qs from "qs";

export default withRouter(({ history, match, location }) => {
  const queryString = qs.parse(location.search.substr(1));

  const deliveryStore_id = queryString.deliveryStore_id
    ? queryString.deliveryStore_id
    : "";
  const dayOfWeek = queryString.dayOfWeek ? queryString.dayOfWeek : "";
  const keyword = queryString.keyword ? queryString.keyword : "";
  const page = queryString.page ? +queryString.page : 1;
  const take = 15;
  const baseUrl = "/deliveryPlaces";

  const { data, loading, error } = useQuery(ADMIN_DELIVERY_PLACE_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      deliveryStore_id,
      dayOfWeek,
      take,
      skip: (page - 1) * take,
      keyword,
    },
  });

  // if (loading) {
  //   return <></>;
  // }
  if (error) {
    return <>{error.message}</>;
  }

  return (
    <Presenter
      history={history}
      match={match}
      location={location}
      deliveryStore_id={deliveryStore_id}
      dayOfWeek={dayOfWeek}
      keyword={keyword}
      page={page}
      take={take}
      loading={loading}
      data={data}
      baseUrl={baseUrl}
    />
  );
});
